<template>
  <v-row>
    <v-col cols="12" xl="4">
      <ChartCard
        id="actionsWebsite"
        :chart="charts.clicks"
        :infoIconColor="infoIconColor"
        :tooltipMaxWidth="tooltipMaxWidth"
        :is-date-in-range="isDateInRange"
        :title="
          $t('message.analytics.businessAddresses.chart.clicks.title.text')
        "
        :tooltip="
          $t('message.analytics.businessAddresses.chart.clicks.title.tooltip')
        "
      />
    </v-col>
    <v-col cols="12" xl="4">
      <ChartCard
        id="actionsDrivingDirections"
        :chart="charts.directions"
        :infoIconColor="infoIconColor"
        :tooltipMaxWidth="tooltipMaxWidth"
        :is-date-in-range="isDateInRange"
        :title="
          $t('message.analytics.businessAddresses.chart.directions.title.text')
        "
        :tooltip="
          $t(
            'message.analytics.businessAddresses.chart.directions.title.tooltip'
          )
        "
      />
    </v-col>
    <v-col cols="12" xl="4">
      <ChartCard
        id="actionsPhone"
        :chart="charts.calls"
        :infoIconColor="infoIconColor"
        :tooltipMaxWidth="tooltipMaxWidth"
        :is-date-in-range="isDateInRange"
        :title="
          $t('message.analytics.businessAddresses.chart.calls.title.text')
        "
        :tooltip="
          $t('message.analytics.businessAddresses.chart.calls.title.tooltip')
        "
      />
    </v-col>
  </v-row>
</template>

<script>
import ChartCard from "./ChartCard.vue";

export default {
  name: "AbsoluteCharts",
  components: {
    ChartCard
  },
  props: {
    charts: {
      type: Object,
      required: true
    },
    infoIconColor: {
      type: String,
      default: "primary"
    },
    tooltipMaxWidth: {
      type: Number,
      default: 500
    },
    isDateInRange: {
      type: Boolean,
      default: true
    }
  }
};
</script>
